const ALGO = { name: "AES-GCM", length: 256 };
const IV_LENGTH = 12; // 96 bits for GCM

let sessionKey = null;

async function getCryptoKey() {
    if (sessionKey) return sessionKey;

    // Derive a 256-bit key from an env-provided secret
    const secret = process.env.REACT_APP_SESSION_ENCRYPTION_KEY || 'fallback_session_encryption_key';
    const secretBytes = new TextEncoder().encode(secret);
    const hash = await crypto.subtle.digest("SHA-256", secretBytes); // 256-bit key material

    sessionKey = await crypto.subtle.importKey("raw", hash, ALGO, false, ["encrypt", "decrypt"]);
    return sessionKey;
}

/**
 * Robust base64 helpers
 * @param {*} buffer 
 * @returns 
 */
function arrayBufferToBase64(buffer) {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.length;
    const chunkSize = 0x8000; // 32KB chunks
    for (let i = 0; i < len; i += chunkSize) {
        binary += String.fromCharCode.apply(null, bytes.subarray(i, Math.min(i + chunkSize, len)));
    }
    return btoa(binary);
}

function base64ToArrayBuffer(base64) {
    const binary = atob(base64);
    const len = binary.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return bytes.buffer;
}

// Encrypt data object
export async function encryptData(dataObj) {
    const iv = crypto.getRandomValues(new Uint8Array(IV_LENGTH));
    const key = await getCryptoKey();
    const data = new TextEncoder().encode(JSON.stringify(dataObj));
    const enc = await crypto.subtle.encrypt({ ...ALGO, iv }, key, data);
    const b64Iv = arrayBufferToBase64(iv);
    const b64Data = arrayBufferToBase64(enc);
    return `${b64Iv}:${b64Data}`;
}

// Decrypt
export async function decryptData(encryptedStr) {
    try {
        const [b64Iv, b64Data] = encryptedStr.split(':');
        const iv = new Uint8Array(base64ToArrayBuffer(b64Iv));
        const data = base64ToArrayBuffer(b64Data);

        const key = await getCryptoKey();
        const dec = await crypto.subtle.decrypt({ name: "AES-GCM", iv }, key, data);
        const str = new TextDecoder().decode(dec);
        // >>> Never enumerate over massive objects here <<<
        return JSON.parse(str);
    } catch (e) {
        console.error('Decryption error', e);
        return null;
    }
}